import React from 'react'
import cx from 'classnames'
import styles from './header.module.scss'
import { PaginationButton } from '../button'
import { Link } from '../link'

export default function Header({ title, previous, next }) {
  return (
    <header className="container container--grid">
      <div className="container__row">
        <div className={styles.header}>
          <div className={styles.header__nav}>
            <PaginationButton
              as={Link}
              to={previous}
              direction="previous"
              aria-label="Previous"
            />
            <PaginationButton as={Link} to={next} aria-label="Next" />
          </div>
          <div className={cx(styles.header__title, 'child-my-0')}>
            <h1 className="type-dfbi-title">{title}</h1>
          </div>
        </div>
      </div>
    </header>
  )
}
